module.exports = __webpack_public_path__ + "static/seo-gokada-4acf1c603877b457e0a378c3f5914dfb.png";